import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    loading: false,
    title: '',
    subtitle: ''
};
const loaderSlice = createSlice({
    name: 'loader',
    initialState: initialState,
    reducers: {
        setLoading(state, action) {
            const { title, subtitle, loading } = action.payload;
            state.loading = loading;
            state.title = title !== null && title !== void 0 ? title : 'Submitting...';
            state.subtitle = subtitle !== null && subtitle !== void 0 ? subtitle : 'Please hang tight for a sec';
        }
    }
});
export const { setLoading } = loaderSlice.actions;
export const selectLoader = (state) => state.loader;
export const loaderReducer = loaderSlice.reducer;
